import {connect} from 'react-redux';
import ContainerHeader from "components/ContainerHeader";
import IntlMessages from "util/IntlMessages";
import LoadingOverlay from "react-loading-overlay";
import {Card, CardBody, CardSubtitle, CardText} from 'reactstrap';
import {AddIcon, FilterList} from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import Flatpickr from 'react-flatpickr';
import moment from 'moment';
import "flatpickr/dist/themes/material_green.css";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { fetchJSON } from "helpers/axios";

import React, {
  Suspense,
  lazy,
  createContext,
} from "react";
import { CircularProgress } from "@material-ui/core";
const Transactions = lazy(() => import("./Transactions"));


const TransactionContext = createContext();

class Transaction extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: true,
      transactions: [],
      page: 1,
      pageSize: 5,
      startDate: "",
      endDate: "",
      tableRef: React.createRef()
    }
  }

  async componentDidMount(){
    try {
      this.loadContent();
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }    
  }

  loadContent = async () => {
    try {
      const response = await fetchJSON(`/api/Admin/GetTransactionAsync?initialPage=${this.state.page}&pageSize=${this.state.pageSize}&initialDate=${this.state.startDate}&finalDate=${this.state.endDate}`, null, 'GET');
        if (response.state === 1) {
          console.log(response);
          this.setState({
            transactions: response.data,
            loader: false    
          });
        } else {
          NotificationManager.error("Unable to load data.");
          this.setState({ loader: false });
        }
    //   }
    } catch (error) {
      console.log("error", error);
      this.setState({loader: false});
      NotificationManager.error("An error occurred.");      
    }    
  }

  handleDateChange = (name, e) => {
    this.setState({ ...this.state, [name]: moment(e[0]).format('YYYY-MM-DD') });
  }

  handleFilterDate = () => {
    this.state.tableRef.current.onQueryChange();
  }  

  render() {
    const { Provider } = TransactionContext;
    const {match, width} = this.props;
    const {transactions, loader, startDate, endDate, tableRef} = this.state;
    // const tableRef = React.createRef();

    return (
      <Provider value={{loader, transactions, startDate, endDate, tableRef}}>
        <div className="app-wrapper">
          <div className="transaction animated slideInUpTiny animation-duration-3">
            <ContainerHeader match={match} title={<IntlMessages id="sidebar.transaction" />} />


            <Card className="shadow border-0">
              <CardBody>
                  <h4>Filter By Date</h4>
                  <div className="row">
                    <div className="col-lg-5 col-sm-12">
                      <p className="mb-1 mt-1 font-weight-bold">Start Date</p>
                      <Flatpickr
                        options={{maxDate: "today" }}
                        className="form-control"
                        name="dates"
                        onChange={(e) => this.handleDateChange('startDate', e)}
                      />
                    </div>
                    <div className="col-lg-5 col-sm-12">
                    <p className="mb-1 mt-1 font-weight-bold">End Date</p>
                      <Flatpickr
                        options={{maxDate: "today" }}
                        className="form-control"
                        name="dates"
                        onChange={(e) => this.handleDateChange('endDate', e)}
                      />
                    </div>
                    <div className="col-lg-2 col-sm-12">
                      <Button className="btn btn-sm mt-4" variant="contained" color="primary" onClick={() => this.handleFilterDate() }> <FilterList /> <span className="pl-2"> Filter</span></Button>
                    </div>
                  </div>
              </CardBody>
            </Card>

            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height:
                      width >= 1200 ? "calc(100vh - 265px)" : "calc(100vh - 245px)",
                  }}
                >
                  <CircularProgress />
                </div>
              }
            >
                <Transactions />
            </Suspense>

          </div>
          <NotificationContainer/>
        </div>        
      </Provider>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { authUser } = auth;
  return { authUser };
};

export default connect(mapStateToProps, {})(Transaction);
export { TransactionContext };
